import * as ActionCable from '@rails/actioncable';

let consumer: ActionCable.Cable | null = null;

export function getCable(): ActionCable.Cable {
  if (!consumer) {
    consumer = ActionCable.createConsumer();
  }

  return consumer;
}

export function disconnectCable(): void {
  if (!consumer) return;

  consumer.disconnect();
  consumer = null;
}
